import { Localized } from '../../../../../../shared/type';
import { ProductThumbnail } from '@services/MarppleShop/features/ProductList/type';

export interface FundingDetailsProps {
  /**
   * 펀딩 이름
   */
  name: Localized<string>;

  /**
   * 펀딩 기간
   */
  start?: Date;
  end?: Date;

  /**
   * 펀딩 썸네일 정보
   */
  thumbnailInfo: ProductThumbnail;

  /**
   * 펀딩 수량
   */
  totalQuantity?: number;
  soldQuantity?: number;

  /**
   * 펀딩 여러 상태
   */
  canSelling?: boolean;
  isSaleEnabled?: boolean;
  isForceOutOfStock?: boolean;
  isPublic?: boolean;
  isQuantityPublic?: boolean;
  outOfStock?: boolean;
}

export class FundingDetails {
  public readonly name: Localized<string>;
  public readonly start?: Date;
  public readonly end?: Date;
  public readonly thumbnailInfo: ProductThumbnail;
  public readonly totalQuantity?: number;
  public readonly soldQuantity?: number;
  public readonly isSaleEnabled?: boolean;
  public readonly isForceOutOfStock?: boolean;
  public readonly isPublic?: boolean;
  public readonly isQuantityPublic?: boolean;
  public readonly canSelling?: boolean;
  public readonly outOfStock?: boolean;

  private constructor(props: FundingDetailsProps) {
    this.name = props.name;
    this.start = props.start;
    this.end = props.end;
    this.thumbnailInfo = props.thumbnailInfo;
    this.totalQuantity = props.totalQuantity;
    this.soldQuantity = props.soldQuantity;
    this.isSaleEnabled = props.isSaleEnabled;
    this.isForceOutOfStock = props.isForceOutOfStock;
    this.isPublic = props.isPublic;
    this.isQuantityPublic = props.isQuantityPublic;
    this.canSelling = props.canSelling;
    this.outOfStock = props.outOfStock;
  }

  public isInEndedPeriod(): boolean {
    if (!this.end) return false;
    const now = new Date();
    return now > this.end;
  }

  public isInSalePeriod(): boolean {
    const now = new Date();
    const isAfterStart = !this.start || now >= this.start;
    const isBeforeEnd = !this.end || now <= this.end;
    return isAfterStart && isBeforeEnd;
  }

  public isOutOfStock(): boolean {
    return Boolean(this.outOfStock) || Boolean(this.isForceOutOfStock) || this.isInEndedPeriod();
  }

  static of(props: FundingDetailsProps): FundingDetails {
    return new FundingDetails(props);
  }
}
